import { useRoute, type RouteProp } from '@react-navigation/native';
import { createStore, Provider } from 'jotai';
import { useLayoutEffect, type ReactNode } from 'react';
import { type FilterListAtom } from './filterList.atom';
import { useFilterListAtom } from './useFilterListAtom';

export const filterListStore = createStore();

type Props = {
  children:
    | ((props: { filterListState: FilterListAtom }) => ReactNode)
    | ReactNode;
};

const InitializeStore = ({ children }: Props) => {
  const { params } = useRoute<
    RouteProp<{
      params: Partial<FilterListAtom>;
    }>
  >();
  const { replaceFilterListAtom } = useFilterListAtom();

  useLayoutEffect(() => {
    // undefined/null 값과 네비게이션 전용 파라미터를 제거하여
    // 필터 atom에는 순수 필터 파라미터만 저장되도록 함
    const EXCLUDED_PARAMS = new Set([
      'next_token',
      'instanceId',
      'query',
      'search_type',
      'filter_token',
      'from_instance_id',
      'from_screen',
    ]);
    const newParams = Object.fromEntries(
      Object.entries(params ?? {}).filter(
        ([key, value]) =>
          value !== undefined &&
          value !== null &&
          !EXCLUDED_PARAMS.has(key),
      ),
    );
    // merge 대신 replace를 사용하여 이전 스크린의 stale 값이 남지 않도록 한다.
    replaceFilterListAtom(newParams);
  }, [params, replaceFilterListAtom]);

  return <>{children}</>;
};

/**
 * - FILTER_LIST atomic을 사용하기 위해 필요한 provider
 * - route params에서 instanceId를 가져와서 각 FilterList가 독립적인 상태를 가지도록 함
 */
export const FilterListAtomProvider = ({ children }: Props) => {
  return (
    <Provider store={filterListStore}>
      <InitializeStore>{children}</InitializeStore>
    </Provider>
  );
};
